module.exports = __webpack_public_path__ + "static/img/zy_2.6888375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zy_2.jpg
// module id = wKzi
// module chunks = 1